import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
// import { Topbar } from './components/navigation/topbar';
import { NotificationIcon } from './components/helpers/notificationIcon';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FooterNew } from './components/common/Footer';
// import './echo';
import { TopbarWithRouter } from './components/navigation/topbar';

const isSafari = !window.chrome && navigator.userAgent.toLowerCase().indexOf('safari') !== -1;

function getLoggedUser() {
  let userInfo = localStorage.getItem('mzad_user_info');
  userInfo = JSON.parse(userInfo);
  return userInfo && userInfo.length > 0 ? userInfo : false;
}
class App extends React.Component {
  componentDidMount() {
    let lng = localStorage.getItem('I18N_LANGUAGE');
    if (lng === 'ar') {
      document.body.classList.add('ar');
    }
    if (isSafari) {
      document.body.classList.add('safari');
    }
  }

  render() {
    let user = getLoggedUser() || false;
    let is_logged = localStorage.getItem('is_logged_in') ? true : false;

    const currentPath = window.location.pathname;
    const hideLayoutRoutes = ['/site-visit', '/map'];
    const hideFooter = ['/site-visit', '/map'];
    const hideLayout = hideLayoutRoutes.some((route) => currentPath.startsWith(route));
    const hideFooterCheck = hideFooter.some((route) => currentPath.startsWith(route));


    return (
      <Router>
        {/* <Topbar is_logged={is_logged} user={user} /> */}
        <TopbarWithRouter is_logged={is_logged} user={user} />

        {!hideLayout && !hideFooterCheck && <FooterNew />}
        {!hideLayout && <NotificationIcon />}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={document.body.classList.contains('ar')}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </Router>
    );
  }
}
export default App;
